/*
 * jQuery.resourceCalendar v1.0.1
 *
 * based on Weekly calendar:
 * http://www.redredred.com.au/
 *
 * Requires:
 * - jquery.resourcecalendar.css
 * - jquery 1.3.x
 * - jquery-ui 1.7.x (widget, drag, drop, resize)
 *
 * Copyright (c) 2010 Evaldas Urbonas
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 *   If you're after a monthly calendar plugin, check out http://arshaw.com/fullcalendar/
 */

const { trackEvent } = BackboneEx.Tool.Analytics;

(function($) {
  function maybeGetBackgroundColourStyle(maybeServiceColour) {
    return maybeServiceColour
      ? `style="background-color: #${maybeServiceColour};"`
      : '';
  }

  function adjustDate(date, bOnClient) {
    // Hard dependency on Wahanda code.
    return Wahanda.Date._adjustDate(date, bOnClient);
  }

  function addTimeToDate(date, minutes) {
    const dt = new Date(date.getTime() + minutes * 60 * 1000);
    return new Date(
      dt.getTime() + (dt.getTimezoneOffset() - date.getTimezoneOffset()) * 60000
    );
  }

  function subtractDateFromDate(date1, date2) {
    return new Date(
      date1.getTime() -
        date2.getTime() +
        (date2.getTimezoneOffset() - date1.getTimezoneOffset()) * 60000
    );
  }

  function areWeekdaysDifferent($day1, $day2) {
    return _.any(['startDate', 'rid'], function(checkKey) {
      return $day1.data(checkKey) != $day2.data(checkKey);
    });
  }

  function getTransitionStyles(left, top) {
    const prefixes = ['-webkit-', '-ms-'];
    const translate = `translate(${left}px, ${top}px)`;
    const styles = {
      transform: translate
    };

    prefixes.forEach(function(prefix) {
      styles[`${prefix}transform`] = translate;
    });

    return styles;
  }

  function getFirstName(fullName) {
    if (!fullName || typeof fullName !== 'string') {
      return fullName;
    }
    return $.trim(fullName).split(' ')[0];
  }

  function setupJsScrolling($calendarContainer) {
    // Scroling with JS: the hourly time block and employee/day row
    let lastTopScroll = 0;
    let lastLeftScroll = 0;
    const $verticalScrollElement = $calendarContainer.find(
      '.wc-grid-timeslot-container'
    );
    const $horizontalScrollElement = $calendarContainer.find('.wc-header');

    // These functions provide scrolling functionality by using the CSS transitions
    // I didn't see a good enough improvement to enable this
    // function scrollLeft (newLeft) {
    //  $horizontalScrollElement.css(
    //    getTransitionStyles(-1 * newLeft, 0)
    //  );
    // }
    // function scrollTop (newTop) {
    //  $verticalScrollElement.css(
    //    getTransitionStyles(0, -1 * newTop)
    //  );
    // }

    const VERTICAL_INITIAL_TOP = parseInt(
      $verticalScrollElement.css('top'),
      10
    );
    function scrollLeft(newLeft) {
      $horizontalScrollElement.css('margin-left', -1 * newLeft);
    }
    function scrollTop(newTop) {
      const top = VERTICAL_INITIAL_TOP - newTop;
      $verticalScrollElement.css('top', top);
    }

    $calendarContainer
      .find('.wc-scrollable-grid')
      .on('scroll', function onScroll(event) {
        const top = event.target.scrollTop;
        const left = event.target.scrollLeft;

        if (lastLeftScroll !== left) {
          scrollLeft(left);
          lastLeftScroll = left;
        }
        if (lastTopScroll !== top) {
          scrollTop(top);
          lastTopScroll = top;
        }
      });
  }

  function buildEventNameHtml(name, isWalkin) {
    return Wahanda.Template.render(
      '{{#walkin}}<img src="/assets/icons/walkin2.png" alt="" /> {{/walkin}}{{name}}',
      {
        name,
        walkin: isWalkin
      }
    );
  }

  // The minimum column width is 100px
  const MIN_COLUMN_WIDTH = 100;

  $.widget('ui.resourceCalendar', {
    /** *********************
     * Initialise calendar *
     ********************** */
    _init() {
      const self = this;
      self.selectedHour = null;
      self.resources = null;
      self.events = null;
      self.loadResources();
      self.bRedrawInProgress = false;
    },

    _init2() {
      const self = this;
      const options = this.options;
      self._computeOptions();
      self._setupEventDelegation();
      self._renderCalendar();
      self._loadCalEvents(this.options.date || adjustDate(new Date(), true));
      self._resizeCalendar();
      self.showCurrentTime();

      $(window).unbind('resize.resourcecalendar');
      $(window).bind('resize.resourcecalendar', function() {
        self._resizeCalendar();
      });

      if (options.bViewChanged == true) {
        options.bViewChanged = false;
        if (options.onViewChange) {
          options.onViewChange(this);
        }
      }
    },

    getTimeRange(start, end, alreadyFormatted) {
      if (!alreadyFormatted) {
        const tf = this.options.timeFormat;
        start = this._formatDate(start, tf);
        end = this._formatDate(end, tf);
      }
      return `${start} - ${end}`;
    },

    autoUpdateMinutes() {
      this.showCurrentTime();
      const id = this.element.attr('id');
      const callback = function() {
        $(`#${id}`).resourceCalendar('autoUpdateMinutes');
      };
      setTimeout(callback, 5000);
    },

    /** ******************
     * public functions *
     ******************* */

    redraw(bForceFullRedraw) {
      // do not start another redraw while one is still in progress
      // to avoid unexpected rendering in Chrome
      if (this.options.bRedrawInProgress) {
        return;
      }

      if (bForceFullRedraw == null) {
        bForceFullRedraw = false;
      }

      this.options.bRedrawInProgress = true;

      const $weekDayColumns = this.element.find('.wc-day-column-inner');
      this._clearEvents();
      this._renderEvents(this.options.events, bForceFullRedraw);

      this.options.bRedrawInProgress = false;
    },

    /*
     * Refresh the events for the currently displayed week.
     */
    refresh() {
      this._loadCalEvents(this.element.data('startDate')); // reload with existing week
    },

    /*
     * Re-renders clean calendar without any data (time scale is updated)
     */
    drawEmpty() {
      this.loadResources(false);
      this._computeOptions();
      this.element.empty();
      this._renderCalendar();
      $weekDayColumns = this.element.find(
        '.wc-status-slots .wc-day-column-inner'
      );
      this._updateDayColumnHeader($weekDayColumns);
      this._resizeCalendar();
    },

    drawEmptyWithScroll() {
      this.loadResources(false);
      this._computeOptions();
      const scrollBeforeDelete = $('.wc-scrollable-grid').scrollTop();
      const timeColumnHeight = $('.wc-grid-timeslot-container').css('top');
      this.element.empty();
      this._renderCalendar();
      $('.wc-scrollable-grid').scrollTop(scrollBeforeDelete);
      $('.wc-grid-timeslot-container').css('top', timeColumnHeight);
      $weekDayColumns = this.element.find(
        '.wc-status-slots .wc-day-column-inner'
      );
      this._updateDayColumnHeader($weekDayColumns);
      this._resizeCalendar();
    },

    /*
     * Clear all events currently loaded into the calendar
     */
    clear() {
      this._clearCalendar();
    },

    showResourceWeekViewByCol(column) {
      const r = this.options.resources[column - 1];
      if (r == null) {
        return;
      }
      this.showWeekView(r.id);
    },

    /*
     * Go to this week
     */
    today() {
      //         this._clearCalendar();
      this._loadCalEvents(adjustDate(new Date(), true));
    },

    /*
     * Go to the previous week relative to the currently displayed week
     */
    prevWeek() {
      // minus more than 1 day to be sure we're in previous week - account for daylight savings or other anomolies
      const newDate = new Date(
        this.element.data('startDate').getTime() - MILLIS_IN_WEEK / 6
      );
      //         this._clearCalendar();
      this._loadCalEvents(newDate);
    },

    /*
     * Go to the next week relative to the currently displayed week
     */
    nextWeek() {
      // add 8 days to be sure of being in prev week - allows for daylight savings or other anomolies
      const newDate = new Date(
        this.element.data('startDate').getTime() +
          MILLIS_IN_WEEK +
          MILLIS_IN_WEEK / 7
      );
      //         this._clearCalendar();
      this._loadCalEvents(newDate);
    },

    setResourceID(rid) {
      this.options.resourceID = rid;
    },

    getDateRange() {
      const date = this.options.date;
      weekStartDate = this._dateFirstDayOfWeek(date);
      weekEndDate = this._dateLastMilliOfWeek(date);
      return { startDate: weekStartDate, endDate: weekEndDate };
    },

    /*
     * Reload the calendar to whatever week the date passed in falls on.
     */
    gotoWeek(date) {
      //         this._clearCalendar();
      this._loadCalEvents(date);
    },

    gotoDate(newDate) {
      if (!this.options.resources) {
        return;
      }
      if (this.options.date.getTime() != newDate.getTime()) {
        this.gotoWeek(newDate);
      }
    },

    gotoResourceDate(newResourceID, newDate) {
      const options = this.options;
      if (!options.resources) {
        return;
      }

      if (!options.dayView && options.resourceID != newResourceID) {
        options.date = newDate;
        this.showWeekView(newResourceID);
      } else {
        this.gotoDate(newDate);
      }
    },

    showDayView(date) {
      const options = this.options;

      if (date) {
        options.date = date;
      }
      options.dayView = true;
      options.bViewChanged = true;
      this._destroyCalendar();
      this._init();
    },

    showWeekView(resourceID) {
      const options = this.options;

      options.resourceID = resourceID;
      options.bViewChanged = true;
      options.dayView = false;
      this._destroyCalendar();
      this._init();
    },

    getDateRange() {
      const date = this.options.date;
      weekStartDate = this._dateFirstDayOfWeek(date);
      weekEndDate = this._dateLastMilliOfWeek(date);
      return { startDate: weekStartDate, endDate: weekEndDate };
    },

    getDate() {
      return new Date(this.options.date);
    },

    getResourceID() {
      let rid = this.options.resourceID;
      if (rid) {
        rid = parseInt(rid, 10);
      }
      return rid;
    },

    getViewType() {
      return this.options.dayView ? 'day' : 'week';
    },

    /*
     * Remove an event based on it's id
     */
    removeEvent(eventId) {
      const self = this;

      self.element.find('.wc-cal-event').each(function() {
        if ($(this).data('calEvent').id === eventId) {
          $(this).remove();
          return false;
        }
      });

      // this could be more efficient rather than running on all days regardless...
      self.element.find('.wc-day-column-inner').each(function() {
        self._adjustOverlappingEvents($(this));
      });
    },

    /*
     * Removes any events that have been added but not yet saved (have no id).
     * This is useful to call after adding a freshly saved new event.
     */
    removeUnsavedEvents() {
      const self = this;

      self.element.find('.wc-new-cal-event').each(function() {
        $(this).remove();
      });

      // this could be more efficient rather than running on all days regardless...
      self.element.find('.wc-day-column-inner').each(function() {
        self._adjustOverlappingEvents($(this));
      });
    },

    /*
     * update an event in the calendar. If the event exists it refreshes
     * it's rendering. If it's a new event that does not exist in the calendar
     * it will be added.
     */
    updateEvent(calEvent) {
      this._updateEventInCalendar(calEvent);
    },

    /*
     * Returns an array of timeslot start and end times based on
     * the configured grid of the calendar. Returns in both date and
     * formatted time based on the 'timeFormat' config option.
     */
    getTimeslotTimes(date) {
      const options = this.options;
      const firstHourDisplayed = options.businessHours.limitDisplay
        ? options.businessHours.start
        : 0;
      const startDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        firstHourDisplayed
      );

      const times = [];
      let startMillis = startDate.getTime();
      for (let i = 0; i < options.timeslotsPerDay; i++) {
        const endMillis = startMillis + options.millisPerTimeslot;
        times[i] = {
          start: new Date(startMillis),
          startFormatted: this._formatDate(
            new Date(startMillis),
            options.timeFormat
          ),
          end: new Date(endMillis),
          endFormatted: this._formatDate(
            new Date(endMillis),
            options.timeFormat
          )
        };
        startMillis = endMillis;
      }
      return times;
    },

    formatDate(date, format) {
      if (format) {
        return this._formatDate(date, format);
      }
      return this._formatDate(date, this.options.dateFormat);
    },

    formatTime(date, format) {
      if (format) {
        return this._formatDate(date, format);
      }
      return this._formatDate(date, this.options.timeFormat);
    },

    getData(key) {
      return this._getData(key);
    },

    showCurrentTime() {
      let d = new Date();
      d = adjustDate(d, true);
      const date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
      this.setMinutes(d.getHours(), d.getMinutes(), date);
    },

    setMinutes(hour, minutes, date) {
      if (this.selectedHour != null) {
        this.selectedHour.find('.wc-status-header-minutes').text('00');
        this.selectedHour.removeClass('wc-status-header-cell-selected');
      }

      const $line = $('.wc-status-line');

      if (this.options.dayView) {
        let d = this.options.date;
        d = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        if (d.getTime() != date.getTime()) {
          $line.hide();
          return;
        }
        $line.css('width', '100%');
      } else {
        const event = {
          start: new Date(date.getTime() + 100),
          end: new Date(date.getTime() + 200),
          rid: this.options.resourceID
        };
        const $columns = this.element.find('.wc-day-column-inner');
        const $day = this._findWeekDayForEvent(event, $columns);
        const $colHours = this.element.find('.wc-grid-timeslot-spacer');
        if ($day) {
          $line.css('width', $day.width() + 2);
          $line.css('left', $day.position().left - $colHours.width() - 1);
        } else {
          $line.hide();
          return;
        }
      }
      $line.show();

      h = $(`#wc-hour-${hour}`);
      h.addClass('wc-status-header-cell-selected');
      let strMinutes;
      if (minutes < 10) {
        strMinutes = `0${minutes}`;
      } else {
        strMinutes = minutes;
      }
      h.find('.wc-status-header-minutes').text(strMinutes);
      this.selectedHour = h;

      const options = this.options;
      let hourCorrection = 0;
      if (options.businessHours.limitDisplay) {
        hourCorrection = options.businessHours.start;
      }

      if (
        hour >= this._getCalendarStartTime() &&
        hour < this._getCalendarEndTime()
      ) {
        $line.css(
          'top',
          options.timeslotHeight *
            options.timeslotsPerHour *
            (hour - hourCorrection + minutes / 60) -
            2
        );
        $line.show();
      } else {
        $line.hide();
      }
    },

    enterBlockoutMode() {
      this.eventHandlersDisabled = this.blockoutMode = true;
      // Resize event is needed for the calendar to re-render. This compensates for
      // hidden navigation pane.
      this._resizeCalendar();
      this._setupMultiBlockCreation();
    },

    _getDefaultEventClickHeight() {
      const options = this.options;

      const oneMinuteTimeslotHeight =
        options.timeslotHeight / (60 / options.timeslotsPerHour);

      return oneMinuteTimeslotHeight * options.defaultEventLength;
    },

    _setupMultiBlockCreation() {
      const self = this;
      const options = this.options;

      function bindEventHandlers($weekDay) {
        $weekDay.on('mousedown.multi-block-mode', function(event) {
          const $target = $(event.target);
          if ($target.hasClass('wc-day-column-inner')) {
            const $newEvent = $(
              '<div class="wc-cal-event sal-event-multi-block new-multi-block"><div class="wc-time"></div></div>'
            );

            $newEvent.css({
              lineHeight: `${options.timeslotHeight - 2}px`,
              fontSize: `${options.timeslotHeight / 2}px`
            });
            $target.append($newEvent);

            const columnOffset = $target.offset().top;
            const clickY = event.pageY - columnOffset;
            const clickYRounded =
              (clickY - (clickY % options.timeslotHeight)) /
              options.timeslotHeight;
            const topPosition = clickYRounded * options.timeslotHeight;
            $newEvent.css({ top: topPosition });

            self.element
              .bind('mousemove.multi-block-mode', function(moveEvent) {
                $newEvent.show();
                $newEvent.addClass('ui-resizable-resizing');
                const height = Math.round(
                  moveEvent.pageY - columnOffset - topPosition
                );
                const newHeight = self._snapBlockHeight(height);
                $newEvent.css('height', newHeight);

                const eventDuration = self._getEventDurationFromPositionedEventElement(
                  $weekDay,
                  $newEvent,
                  topPosition
                );
                $newEvent
                  .find('.wc-time')
                  .text(
                    self.getTimeRange(eventDuration.start, eventDuration.end)
                  );
              })
              .on('mouseup.multi-block-mode', function() {
                self.element.unbind('.multi-block-mode');
                $newEvent.addClass('ui-corner-all');

                if ($newEvent.length) {
                  // if even created from a single click only, default height
                  if (!$newEvent.hasClass('ui-resizable-resizing')) {
                    $newEvent
                      .css({ height: self._getDefaultEventClickHeight() })
                      .show();
                  }
                  const top = parseInt($newEvent.css('top'));
                  const eventDuration = self._getEventDurationFromPositionedEventElement(
                    $weekDay,
                    $newEvent,
                    top
                  );

                  $newEvent.remove();
                  const newCalEvent = {
                    start: eventDuration.start,
                    end: eventDuration.end,
                    title: options.newEventText,
                    rid: $weekDay.data('rid'),
                    originalEvent: event,
                    fid: 'multi-block',
                    type: 'multi-block'
                  };

                  const $renderedCalEvent = self._renderEvent(
                    newCalEvent,
                    $weekDay
                  );

                  if (!options.allowCalEventOverlap) {
                    self._adjustForEventCollisions(
                      $weekDay,
                      $renderedCalEvent,
                      newCalEvent,
                      newCalEvent
                    );
                    self._positionEvent($weekDay, $renderedCalEvent);
                  } else {
                    self._adjustOverlappingEvents($weekDay);
                  }

                  // Add to existing events to render if after window resize
                  self.options.events.push(newCalEvent);
                }
              });
          }
        });
      }

      this.element.find('.wc-day-column-inner').each(function() {
        bindEventHandlers($(this));
      });
    },

    _removeMultiBlock($calEvent, calEvent, $weekDay) {
      $calEvent.remove();
      this.options.events = _.without(this.options.events, calEvent);
      this._adjustOverlappingEvents($weekDay);
    },

    leaveBlockoutMode() {
      this.eventHandlersDisabled = this.blockoutMode = false;

      // Remove the temp blocks
      this.options.events = _.filter(this.options.events, function(evt) {
        return evt.type !== 'multi-block';
      });

      this._resizeCalendar();

      this.element.find('.wc-day-column-inner').each(function() {
        $(this).off('.multi-block-mode');
      });
    },

    _findDayColumnBasedOnXPosition(x) {
      return _.find(this.element.find('.wc-day-column-inner'), function(day) {
        const rect = day.getBoundingClientRect();

        return rect.left <= x && rect.right >= x;
      });
    },

    enterReschedulingMode(options) {
      this.eventHandlersDisabled = true;
      // Redraw calendar with events disabled
      this._resizeCalendar();

      const self = this;
      const $newAppt = $(
        '<div class="wc-cal-event is-being-dragged sal-event-ok reschedule-preview">\
                <div data-hj-suppress class="wc-status"></div>\
                <div data-hj-suppress class="wc-time"></div>\
                <div data-hj-suppress class="wc-client"></div>\
                <div data-hj-suppress class="wc-title"></div>\
                <div data-hj-suppress class="wc-subtitle"></div>\
                </div>'
      );
      const apptHeight = this.calculateHeightFromDuration(options.duration) - 1;

      $newAppt.css({
        height: apptHeight,
        width: '100%',
        display: 'block',
        'z-index': 999,
        opacity: 0.5
      });

      $newAppt
        .find('.wc-client')
        .html(buildEventNameHtml(options.consumerName, options.isWalkin));
      $newAppt.find('.wc-title').text(options.title);

      function positionAppt(target, top) {
        const $target = $(target);

        if (!$newAppt.parent().is($target)) {
          $target.append($newAppt);
        }

        // Don't allow to go out of calendar bounds
        const eventHeight = $newAppt.height();
        if (top + eventHeight > $target.height()) {
          top = $target.height() - eventHeight;
        }

        $newAppt.css({ top: top - 1 });
      }

      // Try positioning the shadow next to the given initial pos
      if (options.initialPosition) {
        const initialDay = this._findDayColumnBasedOnXPosition(
          options.initialPosition.x
        );
        if (initialDay) {
          const correctedPos =
            options.initialPosition.y - initialDay.getBoundingClientRect().top;
          const duration = self._getEventDurationFromPositionedEventElement(
            $(initialDay),
            // A mock calEvent. As it's a DOM Node, we pass in the same weekday.
            $newAppt,
            correctedPos,
            false,
            true
          );
          $newAppt
            .find('.wc-time')
            .html(self.getTimeRange(duration.start, duration.end));
          positionAppt(initialDay, correctedPos);
        }
      }

      this.element.on(
        'mousemove.rcreschedule',
        '.wc-day-column-inner',
        function(event) {
          const $target = $(this);
          const topPosition = self._getTopPositionFiveMinutesSnap(
            event.pageY,
            $target
          );
          positionAppt(this, topPosition);
          // If we have reached the calendar limits, do not update the event times
          if (topPosition + $newAppt.height() > $target.height()) {
            return;
          }

          const duration = self._getEventDurationFromPositionedEventElement(
            $target,
            // A mock calEvent. As it's a DOM Node, we pass in the same weekday.
            $newAppt,
            topPosition,
            false,
            true
          );

          const startTime = self._formatDate(
            duration.start,
            self.options.timeFormat
          );
          const endTime = Wahanda.Time.add(startTime, options.duration);
          $newAppt
            .find('.wc-time')
            .html(self.getTimeRange(startTime, endTime, true));
        }
      );

      // Remove $newAppt block on mouse leave
      this.element.on(
        'mouseleave.rcreschedule',
        '.wc-scrollable-grid',
        function(event) {
          $newAppt.remove();
        }
      );

      this.element.on('click.rcreschedule', '.wc-day-column-inner', function(
        event
      ) {
        const $weekDay = $(this);
        const topPosition = parseInt(
          $newAppt.offset().top - $weekDay.offset().top,
          10
        );
        const duration = self._getEventDurationFromPositionedEventElement(
          $weekDay,
          // A mock calEvent. As it's a DOM Node, we pass in the same weekday.
          $weekDay,
          topPosition,
          false,
          true
        );
        options.onEventNew({
          start: duration.start,
          resourceId: parseInt(
            $weekDay.data('rid') || self.options.resourceID,
            10
          )
        });
      });
    },

    exitReschedulingMode() {
      const $originalDomEvent = $('.reschedule-preview');
      const $originalDomEventParent = $originalDomEvent.parent();
      const $rescheduleDomEvent = $originalDomEvent.clone();

      this.element.off('.rcreschedule');
      this.eventHandlersDisabled = false;
      this._resizeCalendar();
      $originalDomEventParent.append($rescheduleDomEvent);
    },

    getBlockoutEvents() {
      return _.map(this.element.find('.sal-event-multi-block'), function(
        element
      ) {
        return $(element).data('calEvent');
      });
    },

    /** *******************
     * private functions *
     ******************** */
    // compute dynamic options based on other config values
    _computeOptions() {
      const options = this.options;

      if (options.businessHours.limitDisplay) {
        options.timeslotsPerDay =
          options.timeslotsPerHour *
          (options.businessHours.end - options.businessHours.start);
        options.millisToDisplay =
          (options.businessHours.end - options.businessHours.start) *
          60 *
          60 *
          1000;
        options.millisPerTimeslot =
          options.millisToDisplay / options.timeslotsPerDay;
      } else {
        options.timeslotsPerDay = options.timeslotsPerHour * 24;
        options.millisToDisplay = MILLIS_IN_DAY;
        options.millisPerTimeslot = MILLIS_IN_DAY / options.timeslotsPerDay;
      }
    },

    // returns number of columns depending on display mode
    _getColumnCount() {
      const options = this.options;

      if (options.dayView == true) {
        if (options.resources) {
          return options.resources.length;
        }
        return 0;
      }
      return options.daysToShow;
    },

    /*
     * Resize the calendar scrollable height based on the provided function in options.
     */
    _resizeCalendar() {
      const options = this.options;
      this.updateHeight();

      if (options.timeslotsPerHourWhenDragging) {
        this._calculateDraggedSlotHeight();
      }

      this.showCurrentTime();
      this._toggleScrollbarShim();
      this._checkHorizontalScrolling();
      this.options.dontScrollToActiveTime = true;
      this.redraw();
      this.options.dontScrollToActiveTime = false;
    },

    updateHeight() {
      const options = this.options;
      if (options && $.isFunction(options.height)) {
        const calendarHeight = options.height(this.element);
        const headerHeight = this.element.find('.wc-header').outerHeight();
        const navHeight = this.element.find('.wc-nav').outerHeight();
        this.element
          .find('.wc-scrollable-grid')
          .height(calendarHeight - navHeight - headerHeight);
      }
    },

    calculateHeightFromDuration(duration) {
      const numberOfTimesSlots =
        duration / (60 / this.options.timeslotsPerHour);
      const blockHeight = numberOfTimesSlots * this.options.timeslotHeight;

      return blockHeight;
    },

    _getTopPositionFiveMinutesSnap(topPos, $target) {
      const columnOffset = $target.offset().top;
      const hoverY = topPos - columnOffset;

      const hoverYRounded =
        (hoverY - (hoverY % this.options.timeslotHeightWhenDragging)) /
        this.options.timeslotHeightWhenDragging;
      const topPosition =
        hoverYRounded * this.options.timeslotHeightWhenDragging;

      return topPosition;
    },

    _snapBlockHeight(height) {
      const remainder = height % this.options.timeslotHeight;
      // snap to closest timeslot
      let newHeight;
      if (remainder < this.options.timeslotHeight / 2) {
        const useHeight = height - remainder;
        newHeight =
          useHeight < this.options.timeslotHeight
            ? this.options.timeslotHeight
            : useHeight;
      } else {
        newHeight = height + (this.options.timeslotHeight - remainder);
      }
      return newHeight;
    },

    _calculateDraggedSlotHeight() {
      const options = this.options;

      const totalDragSlots =
        options.timeslotsPerHourWhenDragging *
        (options.businessHours.end - options.businessHours.start);
      const diff = options.timeslotsPerDay / totalDragSlots;

      options.timeslotHeightWhenDragging = options.timeslotHeight * diff;
      options.millisPerTimeslotWhenDragging = options.millisPerTimeslot * diff;
    },

    // Check if we do have real horizontal scrolling, to not show scrollbars if only
    // a pixel or two can be scrolled.
    _checkHorizontalScrolling() {
      const $grid = this.element.find('.wc-scrollable-grid');
      const gridEl = $grid[0];
      if (gridEl.scrollWidth - gridEl.clientWidth < 5) {
        $grid.addClass('no-horizontal-scroll');
      }
    },

    _getCalendarStartTime() {
      const options = this.options;

      return options.businessHours.limitDisplay
        ? options.businessHours.start
        : 0;
    },

    _getCalendarEndTime() {
      const options = this.options;

      return options.businessHours.limitDisplay
        ? options.businessHours.end
        : 24;
    },

    /**
     * Checks if the scrollbar shim is needed. This is not always true.
     */
    _toggleScrollbarShim() {
      let isShimNeeded = false;

      // Enable the scroll shim and it's calculations only if that would be of any difference
      // to the browser. This helps prevent false-positives in some cases, e.g. DEV-47198
      if (!Modernizr.hiddenscroll) {
        isShimNeeded =
          this.element.find('.wc-status-slots-container').width() >
          this.element.find('.wc-status-slots').width();
      }

      this.element.find('.wc-scrollbar-shim').toggle(isShimNeeded);
    },

    /*
     * configure calendar interaction events that are able to use event
     * delegation for greater efficiency
     */
    _setupEventDelegation() {
      const self = this;
      const options = this.options;
      const namespace = '.resourcecalendar';
      this.element.off(namespace)
      .on(`touchmove${namespace}`, function(event) {
        // jquery.ui.touch-punch registers _touchMoved and does not simulate click some times
        // this workaround assumes that if touchmove lasted for only 500ms, then it was probably a click
        const $target = $(event.target);
        const isTouchingCalEvent = $target.hasClass('wc-cal-event') || $target.parent().hasClass('wc-cal-event');

        if (!isTouchingCalEvent) {
          return;
        }

        $target.on('touchend.calEventWorkaround', function() {
          $target.click();
        });

        setTimeout(function() {
          $target.off('.calEventWorkaround');
        }, 500);
      })
      .on(`click${namespace}`, function(event) {
        if (self.eventHandlersDisabled) {
          return;
        }

        let $target = $(event.target);
        if ($target.data('preventClick')) {
          return;
        }
        if ($target.hasClass('wc-cal-event')) {
          options.eventClick($target.data('calEvent'), $target, event);
        } else if ($target.parent().hasClass('wc-cal-event')) {
          options.eventClick(
            $target.parent().data('calEvent'),
            $target.parent(),
            event
          );
        } else if (
          $target.hasClass('wc-cal-non-work') ||
          $target.closest('.wc-cal-non-work').length > 0
        ) {
          // Clicking on non work hours
          if ($.isFunction(options.eventClickNonWork)) {
            if (!$target.is('.wc-cal-non-work')) {
              $target = $target.closest('.wc-cal-non-work');
            }
            options.eventClickNonWork($target, event);
          }
        }
      });

      if (!options.hoverEvents) {
        return;
      }

      this.element
        .on(`mouseover${namespace}`, function(event) {
          const $target = $(event.target);

          if (self._isDraggingOrResizing($target)) {
            return;
          }
          if (options.eventMouseover && $target.hasClass('wc-cal-event')) {
            options.eventMouseover($target.data('calEvent'), $target, event);
          }
          if ($target.is('.wc-day-column-inner:not(.has-edit-hint)')) {
            self._showEditHint($target);
          }
        })
        .on(`mouseout${namespace}`, function(event) {
          const $target = $(event.target);
          if (self._isDraggingOrResizing($target)) {
            return;
          }

          if ($target.hasClass('wc-cal-event')) {
            if ($target.data('sizing')) return;
            if (options.eventMouseout) {
              options.eventMouseout($target.data('calEvent'), $target, event);
            }
          }
        });
    },

    /*
     * check if a ui draggable or resizable is currently being dragged or resized
     */
    _isDraggingOrResizing($target) {
      return (
        $target.hasClass('ui-draggable-dragging') ||
        $target.hasClass('ui-resizable-resizing')
      );
    },

    _showEditHint($column, event) {
      // Hint: editing hint
      return;
      // bind to mouseLeave (not if on this element!), then remove all divs
      // bind to mousemove, to calculate where to show the div
      // should let clicks through
      $column.addClass('has-edit-hint');

      const $hint = $(
        `${'<div class="wc-block-link">' +
          '<div class="icon icons-block"></div>'}${
          Wahanda.lang.calendar.events.buttons.clickBlockTime
        }</div>`
      );
      this.element.find('.wc-container:first').append($hint);

      $column
        // Binding mouseout event for destryoing everything created here
        .on('mouseout.edit-hint', function() {
          $column.unbind('.edit-hint');
          $hint.remove();
        });
    },

    /*
     * Render the main calendar layout
     */
    _renderCalendar() {
      let $calendarContainer;
      let calendarNavHtml;
      let calendarHeaderHtml;
      let $weekDayColumns;
      let tableMinWidthCss;
      let minTableWidth;
      let calendarBodyHtml = '';
      const self = this;
      const options = this.options;

      $calendarContainer = $('<div class="wc-container">').appendTo(
        self.element
      );

      if (options.buttons) {
        calendarNavHtml = `<div class="wc-nav">\
                    <button class="wc-today">${options.buttonText.today}</button>\
                    <button class="wc-prev">${options.buttonText.lastWeek}</button>\
                    <button class="wc-next">${options.buttonText.nextWeek}</button>\
                    </div>`;

        $(calendarNavHtml).appendTo($calendarContainer);

        $calendarContainer.find('.wc-nav .wc-today').click(function() {
          self.element.resourceCalendar('today');
          return false;
        });

        $calendarContainer.find('.wc-nav .wc-prev').click(function() {
          self.element.resourceCalendar('prevWeek');
          return false;
        });

        $calendarContainer.find('.wc-nav .wc-next').click(function() {
          self.element.resourceCalendar('nextWeek');
          return false;
        });
      }

      // render calendar header
      // HINT: rendering

      columnsToShow = this._getColumnCount();
      minTableWidth = columnsToShow * MIN_COLUMN_WIDTH;
      tableMinWidthCss = `min-width: ${minTableWidth}px`;

      calendarHeaderHtml =
        '<div data-hj-suppress class="wc-header-container"><div class="wc-header-scroll-curtain"></div>';
      calendarHeaderHtml += `<table data-hj-suppress class="wc-header" style="${tableMinWidthCss}"><tbody>`;
      calendarHeaderHtml += '<tr>';
      for (var i = 1; i <= columnsToShow; i++) {
        strHdrClass = ' ';
        if (options.dayView) {
          if (i == 1) strHdrClass += 'wc-day-column-header-first ';
          if (i == columnsToShow) strHdrClass += 'wc-day-column-header-last ';
          strHdrClass += 'wc-resource-column-header ';
        }
        calendarHeaderHtml += `<td data-hj-suppress class="wc-day-column-header wc-day-${i}${strHdrClass}"></td>`;
      }
      calendarHeaderHtml +=
        '<td class="wc-scrollbar-shim"></td></tr></tbody></table>';
      calendarHeaderHtml += '</div>';

      // render calendar body
      const start = self._getCalendarStartTime();
      const end = self._getCalendarEndTime();

      // HINT: rendering

      calendarBodyHtml += '<div class="wc-status-slots-container">';
      calendarBodyHtml += `<div class="wc-scrollable-grid">\
        <table class="wc-status-slots" style="${tableMinWidthCss}">\
          <tbody>\
            <tr>\
              <td colspan="${columnsToShow}">\
                <div class="wc-status-slot-wrapper">\
                <div class="wc-status-slots">`;

      for (var i = start; i < end; i++) {
        for (let j = 0; j < options.timeslotsPerHour - 1; j++) {
          calendarBodyHtml += '<div class="wc-status-slot"></div>';
        }
        calendarBodyHtml += '<div class="wc-status-slot wc-hour-end"></div>';
      }

      calendarBodyHtml += '<div class="wc-status-line"></div>';

      calendarBodyHtml +=
        '</div></div></td></tr><tr class="wc-day-column-container">';

      for (var i = 1; i <= columnsToShow; i++) {
        calendarBodyHtml += `<td data-test="wc-day-column-${i}" class="wc-day-column day-${i}"><div class="wc-day-column-inner"></div></td>`;
      }

      calendarBodyHtml += '</tr></tbody></table></div></div>';

      // append all calendar parts to container
      $(calendarHeaderHtml + calendarBodyHtml).appendTo($calendarContainer);

      $calendarContainer
        .find('.wc-header')
        .toggleClass('not-clickable', !options.isHeaderNavigationEnabled());

      $weekDayColumns = $calendarContainer.find('.wc-day-column-inner');

      $weekDayColumns.each(function(i, val) {
        $(this).height(options.timeslotHeight * options.timeslotsPerDay);
        if (!options.readonly) {
          self._addDroppableToWeekDay($(this));
          self._setupEventCreationForWeekDay($(this));
        }
      });

      if (!options.dayView) {
        $calendarContainer.find('.wc-header-day-view').click(function() {
          self.showDayView();
        });
      }

      $calendarContainer
        .find('.wc-status-slot')
        .css({ height: options.timeslotHeight });

      // Time slots on the left
      let timeSlots = '';
      for (var i = start; i < end; i++) {
        // HINT: rendering of hours header
        const bhClass =
          options.businessHours.start <= i && options.businessHours.end > i
            ? 'wc-business-hours'
            : '';
        timeSlots += `<div id="wc-hour-${i}" class="wc-hour-header ${bhClass}">`;
        if (options.use24Hour) {
          timeSlots += `${self._24HourForIndex(
            i
          )}<span class="wc-status-header-minutes">00</span>`;
        } else {
          timeSlots += `${self._hourForIndex(
            i
          )}<span class="wc-status-header-minutes">00</span> <span class="wc-am-pm">${self._amOrPm(
            i
          )}</span>`;
        }
        timeSlots += '</div>';
      }
      // Check if calendar has horizontal scrolling:
      // - if there is scrolling, move the time slots into a separate container and scroll them with JS
      // - if no scrolling, the timeslots are in the same container as the calendar body and is scrolled natively.
      const $grid = $calendarContainer.find('.wc-scrollable-grid');
      const hasHorizontalScrolling =
        $grid.prop('clientWidth') < $grid.prop('scrollWidth') - 5;
      $calendarContainer.toggleClass(
        'horizontal-scrolling',
        hasHorizontalScrolling
      );

      if (hasHorizontalScrolling) {
        // Calendar content too wide, use JS scrolling
        $calendarContainer
          .find('.wc-header-container')
          .after(`<div class="wc-grid-timeslot-container">${timeSlots}</div>`);

        setupJsScrolling($calendarContainer);
      } else {
        // No scrolling. Setup the DOM so that the native scroll also scrolls the time slots.
        $calendarContainer
          .find('.wc-header')
          .find('tr:first')
          .prepend('<td class="wc-status-column-header">&nbsp;</td>');

        $calendarContainer
          .find('table.wc-status-slots')
          .find('tr:first')
          .prepend('<td class="wc-grid-timeslot-spacer"></td>');

        $calendarContainer
          .find('.wc-day-column-container')
          .prepend(`<td class="wc-grid-timeslot-spacer">${timeSlots}</td>`);
      }

      $calendarContainer.find('.wc-hour-header').css({
        height: options.timeslotHeight * options.timeslotsPerHour
      });
    },

    /*
     * setup mouse events for capturing new events
     */
    _setupEventCreationForWeekDay($weekDay) {
      const self = this;
      const options = this.options;

      if (!self._isWorkSlotClickable()) {
        $weekDay.addClass('wc-day-column-inner-disabled')
        return;
      }

      $weekDay.mousedown(function(event) {
        if (self.eventHandlersDisabled) {
          return;
        }

        const $target = $(event.target);
        if ($target.hasClass('wc-day-column-inner')) {
          const $newEvent = $(
            '<div class="wc-cal-event wc-new-cal-event wc-new-cal-event-creating"></div>'
          );

          $newEvent.css({
            lineHeight: `${options.timeslotHeight - 2}px`,
            fontSize: `${options.timeslotHeight / 2}px`
          });
          $target.append($newEvent);

          const columnOffset = $target.offset().top;
          const clickY = event.pageY - columnOffset;
          const clickYRounded =
            (clickY - (clickY % options.timeslotHeight)) /
            options.timeslotHeight;
          const topPosition = clickYRounded * options.timeslotHeight;
          $newEvent.css({ top: topPosition });

          options.eventNewStart();

          self.element
            .on('mousemove.newevent', function(event) {
              $newEvent.show();
              $newEvent.addClass('ui-resizable-resizing');
              const height = Math.round(
                event.pageY - columnOffset - topPosition
              );
              const newHeight = self._snapBlockHeight(height);
              $newEvent.css('height', newHeight);
            })
            .on('mouseup.newevent', function() {
              if (self.eventHandlersDisabled) {
                return;
              }

              self.element.unbind('.newevent');
              $newEvent.addClass('ui-corner-all');

              if ($newEvent.length) {
                // if even created from a single click only, default height
                if (!$newEvent.hasClass('ui-resizable-resizing')) {
                  $newEvent
                    .css({ height: self._getDefaultEventClickHeight() })
                    .show();
                }
                const top = parseInt($newEvent.css('top'));
                const eventDuration = self._getEventDurationFromPositionedEventElement(
                  $weekDay,
                  $newEvent,
                  top
                );

                $newEvent.remove();
                const newCalEvent = {
                  start: eventDuration.start,
                  end: eventDuration.end,
                  title: options.newEventText,
                  rid: $weekDay.data('rid'),
                  originalEvent: event
                };

                let $renderedCalEvent;
                options.eventNew(newCalEvent, $renderedCalEvent);
              }
            });
        }
      });
    },

    refreshNonWorkSlots() {
      this._loadNonWorkSlots(this.options.date);
    },

    /*
     * load calendar events for the week based on the date provided
     */
    _loadCalEvents(dateWithinWeek) {
      let date;
      let weekStartDate;
      let endDate;
      let $weekDayColumns;
      const self = this;
      const options = this.options;
      date = dateWithinWeek || options.date;
      date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      options.date = date;
      weekStartDate = self._dateFirstDayOfWeek(date);
      weekEndDate = self._dateLastMilliOfWeek(date);

      if (options.calendarBeforeLoad) {
        options.calendarBeforeLoad(self.element);
      }

      self.element.data('startDate', weekStartDate);
      self.element.data('endDate', weekEndDate);

      $weekDayColumns = self.element.find('.wc-day-column-inner');

      self._updateDayColumnHeader($weekDayColumns);

      self._loadNonWorkSlots(dateWithinWeek);

      // load events by chosen means
      if (typeof options.data === 'string') {
        if (options.loading) options.loading(true);
        const jsonOptions = {};
        jsonOptions[options.startParam || 'start'] = encodeDate(weekStartDate);
        jsonOptions[options.endParam || 'end'] = encodeDate(weekEndDate);
        if (!options.dayView) {
          jsonOptions[options.ridParam || 'rid'] = options.resourceID;
        }
        $.getJSON(options.data, jsonOptions, function(data) {
          self._clearEvents();
          self._renderEvents(data);
          if (options.loading) options.loading(false);
        });
      } else if ($.isFunction(options.data)) {
        options.data(weekStartDate, weekEndDate, options.resourceID, function(
          data
        ) {
          self._clearEvents();
          self._renderEvents(data);
        });
      } else if (options.data) {
        self._clearEvents();
        self._renderEvents(options.data);
      }

      self._disableTextSelect($weekDayColumns);
    },

    /*
     * update the display of each day column header based on the calendar week
     */
    _updateDayColumnHeader($weekDayColumns) {
      const self = this;
      const options = this.options;
      let currentDay = self._cloneDate(self.element.data('startDate'));
      let currentResource = null;
      const resources = options.resources;

      if (!options.dayView) {
        currentResource = options.iResource;

        self.element.find('.sal-res-view-button-work').click(function() {
          if (isRestrictedMode()) {
            return false;
          }
          empWorkEditFormByID(r.id);
        });
        self.element.find('.sal-res-view-button-nonwork').click(function() {
          if (isRestrictedMode()) {
            return false;
          }
          onEmpNonWorkMode();
        });
      } else {
        currentResource = 0;
      }

      self.element
        .find('.wc-header td.wc-day-column-header')
        .each(function(i, val) {
          // HINT: rendering of header

          if (options.dayView) {
            const r = resources[currentResource];
            let picHtml = '';
            if (r.imageId) {
              picHtml = `<img src="${encodeURI(
                r.image_src
              )}" alt="" width="25" height="25" class="pic" />`;
            } else {
              picHtml = Wahanda.InitialsGenerator.generateHTML(r.title, {
                small: true
              });
            }
            if (r.picture) {
              $(this).html(
                `${'<div data-test="employee-calendar-header-name" class="wc-header-name">' +
                  '<div class="person-pic-mini">'}${picHtml}</div>` +
                  `<div class="name">${Wahanda.Util.escapeHtml(
                    getFirstName(r.title)
                  )}</div>` +
                  `</div>`
              );
            } else {
              $(this).html(
                `<div data-test="employee-calendar-header-name" class="wc-header-name">${Wahanda.Util.escapeHtml(
                  r.title
                )}</div>`
              );
            }
            $(this).click(function() {
              trackEvent('calendar', 'edit', 'open-employee-calendar');

              if (options.isHeaderNavigationEnabled()) {
                self.showWeekView(r.id);
              }
            });

            currentResource += 1;
          } else {
            const dayName = options.useShortDayNames
              ? options.shortDays[currentDay.getDay()]
              : options.longDays[currentDay.getDay()];

            $(this).html(
              `${dayName} <span class="sub">${self._formatDate(
                currentDay,
                options.dateFormat
              )}</sub>`
            );
            if (self._isToday(currentDay)) {
              $(this).addClass('wc-today');
            } else {
              $(this).removeClass('wc-today');
            }
            $(this)
              .unbind('click.rcal')
              .bind(
                'click.rcal',
                (function(date) {
                  // Closure.
                  return function() {
                    trackEvent('calendar', 'edit', 'week-view');

                    if (options.isHeaderNavigationEnabled()) {
                      self.options.date = date;
                      self.showDayView();
                    }
                  };
                })(self._cloneDate(currentDay))
              );

            currentDay = self._addDays(currentDay, 1);
          }
        });

      currentDay = self._dateFirstDayOfWeek(
        self._cloneDate(self.element.data('startDate'))
      );

      currentResource = options.dayView ? 0 : options.iResource;

      $weekDayColumns.each(function(i, val) {
        $(this).data('startDate', self._cloneDate(currentDay));
        $(this).data(
          'endDate',
          addTimeToDate(currentDay, MILLIS_IN_DAY / 60000)
        );
        $(this).data(
          'rid',
          currentResource != null ? resources[currentResource].id : null
        );

        if (options.dayView) {
          currentResource += 1;
        } else {
          if (self._isToday(currentDay)) {
            $(this)
              .parent()
              .addClass('wc-today');
          } else {
            $(this)
              .parent()
              .removeClass('wc-today');
          }

          currentDay = self._addDays(currentDay, 1);
        }
      });
    },

    /*
     * Render the events into the calendar
     */
    _renderEvents(events, bForceFullRedraw) {
      const self = this;
      const options = this.options;
      let eventsToRender;
      let updateLayout = false;

      if (bForceFullRedraw == null) {
        bForceFullRedraw = false;
      }

      options.events = events;

      this.showCurrentTime();

      if ($.isArray(events)) {
        eventsToRender = self._cleanEvents(events);
      } else if (events && events.events) {
        eventsToRender = self._cleanEvents(events.events);
      }
      if (events && events.options) {
        // update options
        $.each(events.options, function(key, value) {
          if (value !== options[key]) {
            options[key] = value;
            updateLayout = true;
          }
        });

        self._computeOptions();
      }

      let $weekDayColumns;

      if (updateLayout || bForceFullRedraw) {
        self.element.empty();
        self._renderCalendar();
        self._resizeCalendar();
        $weekDayColumns = self.element.find(
          '.wc-status-slots .wc-day-column-inner'
        );
        self._updateDayColumnHeader($weekDayColumns);
      } else {
        $weekDayColumns = self.element.find(
          '.wc-status-slots .wc-day-column-inner'
        );
      }

      if (eventsToRender) {
        $.each(eventsToRender, function(i, calEvent) {
          const $weekDay = self._findWeekDayForEvent(calEvent, $weekDayColumns);

          if ($weekDay) {
            self._renderEvent(calEvent, $weekDay);
          }
        });
      }

      $weekDayColumns.each(function() {
        self._adjustOverlappingEvents($(this));
      });

      if (options.calendarAfterLoad) {
        options.calendarAfterLoad(self.element);
      }

      if (eventsToRender == null || !eventsToRender.length) {
        options.noEvents();
      }
    },

    /*
     * Render a specific event into the day provided. Assumes correct
     * day for calEvent date
     */
    // HINT: rendering

    _renderEvent(calEvent, $weekDay) {
      const self = this;
      const options = this.options;
      if (calEvent.start.getTime() > calEvent.end.getTime()) {
        return; // can't render a negative height
      }

      const draggingAllowed =
        !options.readonly &&
        !self.eventHandlersDisabled &&
        options.draggable &&
        options.draggable(calEvent, options);
      let eventClass;
      let eventHtml;
      let $calEvent;
      let $modifiedEvent;
      const maybeStyle = maybeGetBackgroundColourStyle(calEvent.serviceColour);

      eventClass = calEvent.id
        ? `wc-cal-event${draggingAllowed ? ' is-draggable' : ''}`
        : 'wc-cal-event wc-new-cal-event';
      eventHtml = `<div class="${eventClass}" ${maybeStyle}>
                <div data-hj-suppress class="wc-status"></div>
                <div data-hj-suppress class="wc-cal-event-header">
                  <div class="wc-time"></div>
                  <div class="wc-indications">
                    <div class="wc-lock"></div>
                    <div class="wc-deposit hidden"></div>
                    <div class="wc-no-deposit-warn hidden"></div>
                    <div class="wc-checkedout hidden"></div>
                    <div class="wc-repeated hidden"></div>
                  </div>
                </div>
                <div data-hj-suppress class="wc-client"></div>
                <div data-hj-suppress class="wc-title"></div>
                <div data-hj-suppress class="wc-subtitle"></div>
                <div data-hj-suppress class="wc-notes"></div>
                </div>`;

      $calEvent = $(eventHtml);

      if (options.eventRender) {
        $modifiedEvent = options.eventRender(calEvent, $calEvent);
      } else {
        $modifiedEvent = $calEvent;
      }
      $calEvent = $modifiedEvent
        ? $modifiedEvent.appendTo($weekDay)
        : $calEvent.appendTo($weekDay);
      $calEvent.css({
        lineHeight: `${options.timeslotHeight - 2}px`,
        fontSize: `${options.timeslotHeight / 2}px`
      });

      self._refreshEventDetails(calEvent, $calEvent);
      self._positionEvent($weekDay, $calEvent);
      $calEvent.show();

      const cEvent = $calEvent.get(0);
      if (cEvent.scrollHeight > cEvent.clientHeight) {
        $calEvent.addClass('minimal-height');
      }

      // Don't draw clean up status bar if finishing times exist
      if (
        calEvent.cleanupPercentage > 0 &&
        calEvent.finishingPercentage === 0 &&
        calEvent.processingPercentage === 0
      ) {
        this.renderCleanupTimeBar(calEvent, $calEvent);
      }

      if (calEvent.processingPercentage > 0) {
        this.renderProcessingTimeBar(calEvent, $calEvent);
      }

      const hasCleanupWithProcessing =
        calEvent.processingEndTime !== null &&
        calEvent.cleanupPercentage !== calEvent.processingPercentage &&
        calEvent.cleanupPercentage > 0 &&
        calEvent.processingPercentage > 0;
      const hasFinishingTime =
        calEvent.finishingPercentage > 0 &&
        calEvent.finishingPercentage !== calEvent.processingPercentage;

      if (hasFinishingTime || hasCleanupWithProcessing) {
        this.renderFinishingTimeBar(calEvent, $calEvent);
      }

      if (
        !options.readonly &&
        options.resizable &&
        options.resizable(calEvent, $calEvent)
      ) {
        self._addResizableToCalEvent(calEvent, $calEvent, $weekDay);
      }
      if (draggingAllowed) {
        self._addDraggableToCalEvent(calEvent, $calEvent);
      }
      if (calEvent.type === 'multi-block') {
        // Remove the temp block onClick
        $calEvent.click(function() {
          self._removeMultiBlock($calEvent, calEvent, $weekDay);
        });
      }

      // NOTE: EUR fixed mouseover with new parameters mouseenter and mouseleave
      if (options.hoverEvents && options.eventMouseEnter) {
        $calEvent.mouseenter(function(event) {
          if (self.eventHandlersDisabled) {
            return;
          }

          let $target = $(event.currentTarget);
          let calEvent = $target.data('calEvent');
          if (!calEvent) {
            $target = $target.parent();
            calEvent = $target.data('calEvent');
          }
          if (self._isDraggingOrResizing($target)) {
            return;
          }
          options.eventMouseEnter(calEvent, $target, event);
        });
      }
      if (options.hoverEvents && options.eventMouseLeave) {
        $calEvent.mouseleave(function(event) {
          if (self.eventHandlersDisabled) {
            return;
          }

          const $target = $(event.currentTarget);
          if (self._isDraggingOrResizing($target)) {
            return;
          }
          if ($target.data('sizing')) return;
          options.eventMouseLeave($target.data('calEvent'), $target, event);
        });
      }

      if (options.eventAfterRender) {
        options.eventAfterRender(calEvent, $calEvent);
      }

      return $calEvent;
    },

    // Render wc-time info
    renderCalendarTime(calEvent, $calEvent, duration, alreadyFormatted) {
      const endTime =
        calEvent.cleanupTime || calEvent.processingEndTime || duration.end;

      $calEvent
        .find('.wc-time')
        .html(this.getTimeRange(duration.start, endTime, alreadyFormatted));
    },

    calculateBarHeight($calEvent, percentage) {
      const calEventHeight = parseFloat(
        window.getComputedStyle($calEvent[0]).height
      );
      const numberOfGridSpaces = Math.ceil(
        calEventHeight / this.options.timeslotHeight
      );

      let barHeight = Math.ceil((calEventHeight * percentage) / 100);
      if (numberOfGridSpaces > 1) {
        barHeight -= 1;
      }

      return barHeight;
    },

    renderCleanupTimeBar(calEvent, $calEvent, $append) {
      const $bar = $('<div>', {
        class: 'wc-cleanup-time'
      });
      const $element = $append || $calEvent;
      const percentage =
        calEvent.cleanupPercentage -
        (calEvent.finishingPercentage > 0 && calEvent.finishingPercentage);
      const height = this.calculateBarHeight($calEvent, percentage);

      $bar.css({ height });
      $element.append($bar);
    },

    renderProcessingTimeBar(calEvent, $calEvent) {
      // Processing time can't be a child of the event as that has `overflow: hidden`.
      const calEventHeight = $calEvent.height();
      const $bar = $('<div>', {
        class: `wc-processing-time ${$calEvent
          .attr('class')
          .replace(/wc\-cal\-event(\-new)?/g, '')}`,
        id: `wc-processing-${calEvent.id}`
      });

      $bar.css({
        height: this.calculateBarHeight(
          $calEvent,
          calEvent.processingPercentage
        ),
        top: parseFloat($calEvent.css('top'), 10) + calEventHeight + 1,
        left: $calEvent.css('left')
      });
      $calEvent.parent().append($bar);
    },

    renderFinishingTimeBar(calEvent, $calEvent) {
      const calEventHeight = $calEvent.height();
      const $bar = $('<div>', {
        class: `wc-cal-event wc-finishing-time ${$calEvent
          .attr('class')
          .replace(/wc\-cal\-event(\-new)?/g, '')}`,
        id: `wc-finishing-${calEvent.id}`
      });
      $bar.append(`<div data-hj-suppress class="wc-status" /><div data-hj-suppress class="wc-client" />`);
      $bar
        .find('.wc-client')
        .html(buildEventNameHtml(calEvent.client, calEvent.walkIn));
      this.renderCleanupTimeBar(calEvent, $calEvent, $bar);

      const heightPercentage =
        calEvent.cleanupPercentage > 0
          ? calEvent.cleanupPercentage
          : calEvent.finishingPercentage;
      let top = parseFloat($calEvent.css('top'), 10) + calEventHeight + 2;
      let height = this.calculateBarHeight(
        $calEvent,
        heightPercentage -
          (calEvent.processingPercentage > 0 && calEvent.processingPercentage)
      );

      if (calEvent.processingPercentage > 0) {
        top += this.calculateBarHeight(
          $calEvent,
          calEvent.processingPercentage
        );
      }

      $bar.css({
        height,
        width: $calEvent.width(),
        top,
        display: 'block',
        left: $calEvent.css('left'),
        backgroundColor: `#${calEvent.serviceColour}`
      });
      $calEvent.parent().append($bar);

      // Store data to manage overlapping
      $bar.data('calEvent', {
        ...calEvent,
        isAdditionalTimeBlock: true,
        start: calEvent.processingEndTime,
        end: calEvent.cleanupTime || calEvent.finishingEndTime,
        eventStart: calEvent.end
      });

      // Add mouseover/mouseleave events to enable to show event
      // appointment tooltip view
      $bar.mouseover(function() {
        $calEvent.mouseover();
        $calEvent.addClass('to-front');
      });
      $bar.mouseleave(function() {
        $calEvent.mouseleave();
        $calEvent.removeClass('to-front');
      });
    },

    /*
     * load non-work slots for the week based on the date provided
     */

    _loadNonWorkSlots(dateWithinWeek) {
      let date;
      let weekStartDate;
      let endDate;
      let $weekDayColumns;
      const self = this;
      const options = this.options;
      date = dateWithinWeek || options.date;
      weekStartDate = self._dateFirstDayOfWeek(date);
      weekEndDate = self._dateLastMilliOfWeek(date);

      $weekDayColumns = self.element.find('.wc-day-column-inner');

      // load events by chosen means
      if (typeof options.resourceWorkTime === 'string') {
        if (options.loading) options.loading(true);
        const jsonOptions = {};
        jsonOptions[options.startParam || 'start'] = encodeDate(weekStartDate);
        jsonOptions[options.endParam || 'end'] = encodeDate(weekEndDate);
        if (!options.dayView) {
          jsonOptions[options.ridParam || 'rid'] = options.resourceID;
        }
        $.getJSON(options.resourceWorkTime, jsonOptions, function(
          resourceWorkTime
        ) {
          resourceWorkTime = self._cleanEvents(resourceWorkTime);
          self._clearNonWorkSlots();
          self._renderNonWorkSlots(resourceWorkTime, $weekDayColumns);
          if (options.loading) options.loading(false);
        });
      } else if ($.isFunction(options.resourceWorkTime)) {
        options.resourceWorkTime(weekStartDate, weekEndDate, function(
          resourceWorkTime
        ) {
          self._clearNonWorkSlots();
          self._renderNonWorkSlots(resourceWorkTime, $weekDayColumns);
        });
      } else if (options.resourceWorkTime) {
        self._clearNonWorkSlots();
        self._renderNonWorkSlots(options.resourceWorkTime, $weekDayColumns);
      }
    },

    /*
     * Render the non-work slots into the calendar
     */
    _renderNonWorkSlots(events, $weekDayColumns) {
      const self = this;
      const options = this.options;
      let eventsToRender;
      let arrWorkHours;
      const arrNonWorks = [];
      let workSlot;

      if ($.isArray(events)) {
        e = events;
      } else if (events.events) {
        e = events.events;
      }

      const n = e.length;

      let dayStart;
      let dayEnd;
      let dateStart;
      let dateEnd;

      if (options.businessHours.limitDisplay) {
        dayStart = options.businessHours.start;
        dayEnd = options.businessHours.end;
      } else {
        dayStart = 0;
        dayEnd = 24;
      }

      for (let i = 0; i < n; i++) {
        workSlot = e[i];
        dateStart = new Date(
          workSlot.start.getFullYear(),
          workSlot.start.getMonth(),
          workSlot.start.getDate(),
          dayStart
        );
        dateEnd = new Date(
          workSlot.end.getFullYear(),
          workSlot.end.getMonth(),
          workSlot.end.getDate(),
          dayEnd
        );

        const sharedProps = {
          rid: workSlot.rid
        };
        if (dateStart < workSlot.start) {
          arrNonWorks.push({
            ...sharedProps,
            start: dateStart,
            end: workSlot.start
          });
        }
        if (workSlot.end < dateEnd) {
          arrNonWorks.push({
            ...sharedProps,
            start: workSlot.end,
            end: dateEnd
          });
        }
      }

      eventsToRender = self._cleanEvents(arrNonWorks);

      $.each(eventsToRender, function(i, calEvent) {
        const $weekDay = self._findWeekDayForEvent(calEvent, $weekDayColumns);

        if ($weekDay) {
          self._renderNonWorkSlot(calEvent, $weekDay);
        }
      });

      // darken non-working hours blocks on hover, but only when they are editable (i.e in day view)
      // OR when there is only one employee/menu group
      // Do not darken when the event handlers are disabled either
      if (self._isNonWorkSlotClickable()) {
        $('.wc-cal-non-work').hover(function(evt) {
          if (self.eventHandlersDisabled) {
            return;
          }
          self.element.toggleClass(
            'wc-cal-non-work-hover',
            evt.type === 'mouseenter'
          );
        });
      }
    },

    /*
     * Render a specific non-work slot into the day provided. Assumes correct
     * day for calEvent date
     */
    // HINT: rendering of non-work hours
    _renderNonWorkSlot(calEvent, $weekDay) {
      const self = this;
      const options = this.options;
      if (calEvent.start.getTime() > calEvent.end.getTime()) {
        return; // can't render a negative height
      }

      let eventClass;
      let eventHtml;
      let $calEvent;
      let $modifiedEvent;

      eventClass = 'wc-cal-non-work';
      eventHtml = `<div class="${eventClass}"></div>`;

      $calEvent = $(eventHtml);
      $calEvent = $calEvent.appendTo($weekDay);
      $calEvent.css('lineHeight', `${options.timeslotHeight - 2}px`);

      $calEvent.data('calEvent', calEvent);
      self._positionEvent($weekDay, $calEvent);

      // only show edit non-working hours message in day view
      if (self._isNonWorkSlotClickable()) {
        self._setupNonWorkSlotClickToEdit($calEvent);
      }

      $calEvent.show();

      return $calEvent;
    },

    _isWorkSlotClickable() {
      const options = this.options;
      return (
        options.resources && Wahanda.Permissions.editOwnCalendar()
      );
    },

    _isNonWorkSlotClickable() {
      const options = this.options;
      const employeeId = options.resourceID;
      return (
        options.hoverEvents &&
        options.resources && Wahanda.Permissions.editRotaCalendar(employeeId)
      );
    },

    _setupNonWorkSlotClickToEdit($event) {
      const $link = $(
        `${'<div class="wc-edit-link">' +
          '<div class="icon icons-edit"></div>'}${
          Wahanda.lang.calendar.events.buttons.clickEditWorkHours
        }</div>`
      );
      $event.append($link);

      // TODO: onClick call some event
    },

    _getResourceIndex(resourceID) {
      const self = this;
      const options = self.options;
      const n = options.resources.length;

      for (let i = 0; i < n; i++) {
        if (options.resources[i].id == resourceID) {
          return i;
        }
      }

      return null;
    },

    destroyResources(newRid) {
      this.options.resourceID = newRid || null;
      this.options.resources = null;
      this.options.iResource = null;
    },

    /*
     * load resources information
     */

    loadResources(bFullLoad) {
      const self = this;
      const options = this.options;

      if (bFullLoad == null) {
        bFullLoad = true;
      }

      // load resources by chosen means
      if (typeof options.srcResources === 'string') {
        if (options.loading) options.loading(true);
        $.getJSON(options.srcResources, null, function(resources) {
          options.resources = resources;
          if (options.loading) options.loading(false);
          if (!options.dayView && resources.length == 1) {
            options.resourceID = resources[0].id;
          }
          options.iResource = self._getResourceIndex(options.resourceID);

          if (bFullLoad) {
            self._init2();
          }
        });
      } else if ($.isFunction(options.srcResources)) {
        options.srcResources(function(resources) {
          options.resources = resources;
          if (
            !options.dayView &&
            options.resourceID == null &&
            resources.length == 1
          ) {
            options.resourceID = resources[0].id;
          }
          options.iResource = self._getResourceIndex(options.resourceID);
          if (bFullLoad) {
            self._init2();
          }
        });
      } else if (options.srcResources) {
        options.resources = options.srcResources;
        if (
          !options.dayView &&
          options.resourceID == null &&
          options.resources.length == 1
        ) {
          options.resourceID = options.resources[0].id;
        }
        options.iResource = self._getResourceIndex(options.resourceID);
        if (bFullLoad) {
          self._init2();
        }
      }
    },

    _adjustOverlappingEvents($weekDay) {
      const self = this;
      if (self.options.allowCalEventOverlap) {
        const groupsList = self._groupOverlappingEventElements($weekDay);
        $.each(groupsList, function() {
          const curGroups = this;
          $.each(curGroups, function(groupIndex) {
            const curGroup = this;

            // do we want events to be displayed as overlapping
            if (self.options.overlapEventsSeparate) {
              // Define width of empty gap to leave on the right of the block
              // This is so the user can book an appointment/block at the same time for the same employee
              // Exception: in blockout mode don't show the gap.
              const gapWidth = self.blockoutMode ? 1 : 8;
              const availableWidth = $weekDay.width() - gapWidth;
              var newWidth = Math.floor(availableWidth / curGroups.length);
              var newLeft;
              if (groupIndex === 0) {
                newLeft = -1;
              } else {
                newLeft = groupIndex * (newWidth + 1) - 1;
              }

              const isDayView = self.getViewType() === 'day';
              const hasOneGroup = curGroups.length === 1;
              const hasSingleEmployee = self.options.resources.length === 1;
              const shouldFitPopoverOnRight = isDayView && hasOneGroup && hasSingleEmployee;

              if (shouldFitPopoverOnRight) {
                const popoverWidth = 269;
                newWidth = availableWidth - gapWidth - popoverWidth;
              } else if (curGroups.length === groupIndex + 1) {
                newWidth = availableWidth - newLeft;
              };

            } else {
              // TODO what happens when the group has more than 10 elements
              var newWidth = 100 - (curGroups.length - 1) * 10;
              var newLeft = groupIndex * 10;
            }

            $.each(curGroup, function() {
              // bring mouseovered event to the front
              if (
                self.options.hoverEvents &&
                !self.options.overlapEventsSeparate
              ) {
                $(this).bind('mouseover.z-index', function() {
                  const $elem = $(this);
                  $.each(curGroup, function() {
                    $(this).css({ 'z-index': '1' });
                  });
                  $elem.css({ 'z-index': '3' });
                });
              }

              self.adjustConnectedEvents(this, newWidth, newLeft);
            });
          });
        });
      }
    },

    adjustConnectedEvents(event, newWidth, newLeft) {
      const calEvent = event.data('calEvent');
      const $processingBar = $(`#wc-processing-${calEvent.id}`);
      const processingBarPosition = $processingBar.position();
      const $finishingBar = $(`#wc-finishing-${calEvent.id}`);
      const adjustStyles = {
        width: newWidth,
        left: newLeft,
        right: 0
      };

      // Adjust calEvent
      if (!calEvent.isAdditionalTimeBlock) {
        $(event).css(adjustStyles);
        if (calEvent.processingEndTime) {
          $processingBar.css('left', newLeft);
        }
        if (calEvent.finishingEndTime) {
          $finishingBar.css(adjustStyles);
        }
      }

      // Adjust additional event block
      if (calEvent.isAdditionalTimeBlock) {
        if (processingBarPosition && processingBarPosition.left <= 0) {
          $(event).css(adjustStyles);
        }
      }
    },

    /*
     * Find groups of overlapping events
     */
    _groupOverlappingEventElements($weekDay) {
      let $events = $weekDay.find('.wc-cal-event:visible');
      // Excluding full/partial blocks
      $events = $events.not('.sal-event-partial-block, .sal-event-full-block');
      const sortedEvents = $events.sort(function(a, b) {
        return (
          $(a)
            .data('calEvent')
            .start.getTime() -
          $(b)
            .data('calEvent')
            .start.getTime()
        );
      });

      let lastEndTime = new Date(0, 0, 0);
      const groups = [];
      let curGroups = [];
      let $curEvent;
      $.each(sortedEvents, function() {
        $curEvent = $(this);
        // checks, if the current group list is not empty, if the overlapping is finished
        if (curGroups.length > 0) {
          if (
            lastEndTime.getTime() <= $curEvent.data('calEvent').start.getTime()
          ) {
            // finishes the current group list by adding it to the resulting list of groups and cleans it
            groups.push(curGroups);
            curGroups = [];
          }
        }

        // finds the first group to fill with the event
        for (let groupIndex = 0; groupIndex < curGroups.length; groupIndex++) {
          if (curGroups[groupIndex].length > 0) {
            // checks if the event starts after the end of the last event of the group
            const lastEvent =
              curGroups[groupIndex][curGroups[groupIndex].length - 1];

            if (eventTimeGroupsMatch(lastEvent, $curEvent)) {
              curGroups[groupIndex].push($curEvent);
              if (lastEndTime.getTime() < getEndTime($curEvent).getTime()) {
                lastEndTime = getEndTime($curEvent);
              }
              return;
            }
          }
        }
        // if not found, creates a new group
        curGroups.push([$curEvent]);
        if (lastEndTime.getTime() < getEndTime($curEvent).getTime()) {
          lastEndTime = getEndTime($curEvent);
        }
      });
      // adds the last groups in result
      if (curGroups.length > 0) {
        groups.push(curGroups);
      }
      return groups;

      // Helper functions

      // "Group matches" means that the event should fit in the same slot as the other event, one
      // after another, NOT next to each other.
      function eventTimeGroupsMatch($evt1, $evt2) {
        const calEvent1 = $evt1.data('calEvent');
        const calEvent2 = $evt2.data('calEvent');
        return calEvent1.end.getTime() <= calEvent2.start.getTime();
      }

      function getEndTime($evt) {
        const data = $evt.data('calEvent');
        return data.end;
      }
    },

    /*
     * find the weekday in the current calendar that the calEvent falls within
     */
    _findWeekDayForEvent(calEvent, $weekDayColumns) {
      let $weekDay;
      $weekDayColumns.each(function() {
        if ($(this).data('startDate') == null) {
          return false;
        }
        if (
          $(this)
            .data('startDate')
            .getTime() <= calEvent?.start?.getTime() &&
          $(this)
            .data('endDate')
            .getTime() >= calEvent?.end?.getTime() &&
          $(this).data('rid') == calEvent.rid
        ) {
          $weekDay = $(this);
          return false;
        }
      });
      return $weekDay;
    },

    /*
     * update the events rendering in the calendar. Add if does not yet exist.
     */
    _updateEventInCalendar(calEvent) {
      const self = this;
      const options = this.options;
      self._cleanEvent(calEvent);

      if (calEvent.id) {
        self.element.find('.wc-cal-event').each(function() {
          if (
            $(this).data('calEvent').id === calEvent.id ||
            $(this).hasClass('wc-new-cal-event')
          ) {
            $(this).remove();
            return false;
          }
        });
      }

      const $weekDay = self._findWeekDayForEvent(
        calEvent,
        self.element.find('.wc-status-slots .wc-day-column-inner')
      );
      if ($weekDay) {
        const $calEvent = self._renderEvent(calEvent, $weekDay);
        self._adjustForEventCollisions($weekDay, $calEvent, calEvent, calEvent);
        self._refreshEventDetails(calEvent, $calEvent);
        self._positionEvent($weekDay, $calEvent);
        self._adjustOverlappingEvents($weekDay);
      }
    },

    _destroyCalendar() {
      if (this.options.beforeDestroyCalendar) {
        this.options.beforeDestroyCalendar();
      }
      this.element.html('');
    },

    /*
     * Position the event element within the weekday based on it's start / end dates.
     */
    _positionEvent($weekDay, $calEvent) {
      const options = this.options;
      const endHour = options.businessHours.end;

      function getLimitedEndDate(calEvent) {
        const eventEndHour = calEvent.end.getHours();
        if (
          calEvent.restrictTime &&
          (eventEndHour > endHour ||
            (eventEndHour === endHour && calEvent.end.getMinutes() > 0))
        ) {
          const newDate = new Date(calEvent.end);
          newDate.setHours(endHour);
          newDate.setMinutes(0);
          newDate.setSeconds(0);
          return newDate;
        }
        return calEvent.end;
      }

      const calEvent = $calEvent.data('calEvent');
      const pxPerMillis = $weekDay.height() / options.millisToDisplay;
      const firstHourDisplayed = options.businessHours.limitDisplay
        ? options.businessHours.start
        : 0;
      const startMillis = subtractDateFromDate(
        calEvent.start,
        new Date(
          calEvent.start.getFullYear(),
          calEvent.start.getMonth(),
          calEvent.start.getDate(),
          firstHourDisplayed
        )
      );
      const eventMillis = subtractDateFromDate(
        getLimitedEndDate(calEvent),
        calEvent.start
      );
      let pxTop = pxPerMillis * startMillis;
      let pxHeight = pxPerMillis * eventMillis;
      if (pxTop < 0) {
        pxHeight += pxTop;
        pxTop = 0;
      }

      // fix event height problem
      pxHeight -= 1;
      pxTop -= 1;
      $calEvent.css({ top: pxTop, height: pxHeight });
    },

    /*
     * Determine the actual start and end times of a calevent based on it's
     * relative position within the weekday column and the starting hour of the
     * displayed calendar.
     */
    _getEventDurationFromPositionedEventElement(
      $weekDay,
      $calEvent,
      top,
      maybeCalEvent,
      isDrag
    ) {
      const options = this.options;
      const startOffsetMillis = options.businessHours.limitDisplay
        ? options.businessHours.start * 60 * 60 * 1000
        : 0;

      const tsHeight = isDrag
        ? options.timeslotHeightWhenDragging
        : options.timeslotHeight;
      const millisPerSlot = isDrag
        ? options.millisPerTimeslotWhenDragging
        : options.millisPerTimeslot;

      const start = addTimeToDate(
        $weekDay.data('startDate'),
        (startOffsetMillis + Math.round(top / tsHeight) * millisPerSlot) / 60000
      );
      let end;
      if (maybeCalEvent) {
        // Fix for DEV-9554: as the endTime isn't calculated correctly and we don't support resizing,
        // just take previous duration and add to startTime
        end = addTimeToDate(
          start,
          (maybeCalEvent.end.getTime() - maybeCalEvent.start.getTime()) / 60000
        );
      } else {
        end = addTimeToDate(
          start,
          ((($calEvent.innerHeight() + 0) / tsHeight) * millisPerSlot) / 60000
        );
      }
      return { start, end };
    },

    /*
     * If the calendar does not allow event overlap, adjust the start or end date if necessary to
     * avoid overlapping of events. Typically, shortens the resized / dropped event to it's max possible
     * duration  based on the overlap. If no satisfactory adjustment can be made, the event is reverted to
     * it's original location.
     */
    _adjustForEventCollisions(
      $weekDay,
      $calEvent,
      newCalEvent,
      oldCalEvent,
      maintainEventDuration
    ) {
      const options = this.options;

      if (options.allowCalEventOverlap) {
        return;
      }
      let adjustedStart;
      let adjustedEnd;
      const self = this;

      $weekDay
        .find('.wc-cal-event')
        .not($calEvent)
        .each(function() {
          const currentCalEvent = $(this).data('calEvent');

          // has been dropped onto existing event overlapping the end time
          if (
            newCalEvent.start.getTime() < currentCalEvent.end.getTime() &&
            newCalEvent.end.getTime() >= currentCalEvent.end.getTime()
          ) {
            adjustedStart = currentCalEvent.end;
          }

          // has been dropped onto existing event overlapping the start time
          if (
            newCalEvent.end.getTime() > currentCalEvent.start.getTime() &&
            newCalEvent.start.getTime() <= currentCalEvent.start.getTime()
          ) {
            adjustedEnd = currentCalEvent.start;
          }
          // has been dropped inside existing event with same or larger duration
          if (
            !oldCalEvent.resizable ||
            (newCalEvent.end.getTime() <= currentCalEvent.end.getTime() &&
              newCalEvent.start.getTime() >= currentCalEvent.start.getTime())
          ) {
            adjustedStart = oldCalEvent.start;
            adjustedEnd = oldCalEvent.end;
            return false;
          }
        });

      newCalEvent.start = adjustedStart || newCalEvent.start;

      if (adjustedStart && maintainEventDuration) {
        newCalEvent.end = new Date(
          adjustedStart.getTime() +
            (oldCalEvent.end.getTime() - oldCalEvent.start.getTime())
        );
        self._adjustForEventCollisions(
          $weekDay,
          $calEvent,
          newCalEvent,
          oldCalEvent
        );
      } else {
        newCalEvent.end = adjustedEnd || newCalEvent.end;
      }

      // reset if new cal event has been forced to zero size
      if (newCalEvent.start.getTime() >= newCalEvent.end.getTime()) {
        newCalEvent.start = oldCalEvent.start;
        newCalEvent.end = oldCalEvent.end;
      }

      $calEvent.data('calEvent', newCalEvent);
    },

    /*
     * Add draggable capabilities to an event
     */
    _addDraggableToCalEvent(calEvent, $calEvent) {
      const self = this;
      const options = this.options;
      const $weekDay = self._findWeekDayForEvent(
        calEvent,
        self.element.find('.wc-status-slots .wc-day-column-inner')
      );

      let lastPos = null;
      let timeChangeAllowed = true;

      const dragOptions = {
        containment: '.wc-scrollable-grid',
        appendTo: '.wc-scrollable-grid',
        revert: 'valid',
        revertDuration: 0,
        opacity: 0.5,
        grid: [
          $calEvent.width() + 1,
          options.timeslotHeightWhenDragging || options.timeslotHeight
        ],
        helper: options.dragHelper,
        distance: 5,
        start(event, ui) {
          const $calEvent = ui.helper;
          options.eventDrag(calEvent, $calEvent);
        },
        drag(event, ui) {
          // And update the start end time in the Appt accordingly
          const newPos = ui.position;
          if (!timeChangeAllowed) {
            return;
          }
          if (
            lastPos &&
            lastPos.left === newPos.left &&
            lastPos.top === newPos.top
          ) {
            return;
          }
          lastPos = newPos;

          // Update start/end time for the dragged helper
          const $newCalEvent = ui.helper;
          const top = parseInt(newPos.top, 10);
          const eventDuration = self._getEventDurationFromPositionedEventElement(
            $weekDay,
            $newCalEvent,
            top,
            calEvent,
            true
          );
          self.renderCalendarTime(calEvent, $newCalEvent, eventDuration);
        },
        stop() {
          lastPos = null;

          if (options.eventDragStop) {
            options.eventDragStop.apply(null, arguments);
          }
        }
      };

      if (calEvent.type === 'block') {
        if (/x|y/.test(calEvent.draggable)) {
          dragOptions.axis = calEvent.draggable;
        } else if (options.dayView) {
          // Don't allow changing the employee for Blocks.
          dragOptions.axis = 'y';
        }

        if (dragOptions.axis === 'y') {
          $calEvent.data('no-date-change', true);
        }
      } else if (calEvent.draggable === 'only-rid') {
        // Allow only employee changes.
        dragOptions.axis = 'x';
        timeChangeAllowed = false;
      } else if (calEvent.draggable === 'only-edit-own-cal') {
        // Allow only appt time changes for the same employee
        dragOptions.axis = 'y';
        $calEvent.data('no-date-change', true);
      }

      $calEvent.draggable(dragOptions);
    },

    /*
     * Add droppable capabilites to weekdays to allow dropping of calEvents only
     */
    _addDroppableToWeekDay($weekDay) {
      const self = this;
      $weekDay.droppable({
        accept: '.wc-cal-event',
        drop(event, ui) {
          const $newCalEvent = ui.helper || ui.draggable;
          const $oldCalEvent = ui.draggable;

          let $weekdayTarget = $weekDay;
          if (
            $oldCalEvent.data('no-date-change') &&
            $weekDay.find($oldCalEvent).length === 0
          ) {
            // Dragging to another date isn't allowed. But as droppable accepts it, need to work around.
            $weekdayTarget = $oldCalEvent.closest('.wc-day-column-inner');
          }

          self._replaceEvent(
            $weekdayTarget,
            $oldCalEvent,
            $newCalEvent,
            parseInt(ui.position.top, 10),
            $weekdayTarget.data('rid') || calEvent.rid,
            false
          );
        },
        deactivate(event, ui) {
          self.options.eventDeactivate();
        }
      });
    },

    _replaceEvent($weekDay, $oldCalEvent, $newCalEvent, top, rid, isRevert) {
      const calEvent = $oldCalEvent.data('calEvent');
      let newCalEvent;

      if (isRevert) {
        newCalEvent = $newCalEvent.data('calEvent');
      } else if (calEvent.draggable === 'only-rid') {
        newCalEvent = $.extend({}, calEvent, {
          rid
        });
      } else {
        const eventDuration = this._getEventDurationFromPositionedEventElement(
          $weekDay,
          $newCalEvent,
          top,
          calEvent,
          true
        );
        newCalEvent = $.extend({}, calEvent, {
          start: eventDuration.start,
          end: eventDuration.end,
          rid
        });
      }
      this._adjustForEventCollisions(
        $weekDay,
        $newCalEvent,
        newCalEvent,
        calEvent,
        true
      );
      const $weekDayColumns = this.element.find('.wc-day-column-inner');
      const $newEvent = this._renderEvent(
        newCalEvent,
        this._findWeekDayForEvent(newCalEvent, $weekDayColumns)
      );
      $newCalEvent.hide();

      if (!isRevert) {
        // Cache the value as after it's removed from DOM also the `data` is removed
        const oldEventData = $oldCalEvent.data();
        const $oldEventWeekday = $oldCalEvent.closest('.wc-day-column-inner');

        this.options.eventDrop(
          newCalEvent,
          calEvent,
          $newEvent,
          function revert() {
            // Restore data
            $oldCalEvent.data(oldEventData);
            // Also need to hide the reverted event for Calendar rendering to work OK
            $newEvent.hide();
            // Remove all processing and finishing time bars for this event. They will be recreated later on.
            let $ptBar;
            while (
              ($ptBar = $(
                `#wc-processing-${calEvent.id}, #wc-finishing-${calEvent.id}`
              )).length > 0
            ) {
              $ptBar.remove();
            }
            this._replaceEvent(
              $oldEventWeekday,
              $newEvent,
              $oldCalEvent,
              null,
              null,
              true
            );
          }.bind(this)
        );
      }

      $newCalEvent.data('preventClick', true);

      const $weekDayOld = this._findWeekDayForEvent(
        calEvent,
        this.element.find('.wc-status-slots .wc-day-column-inner')
      );

      if (areWeekdaysDifferent($weekDayOld, $weekDay)) {
        this._adjustOverlappingEvents($weekDayOld);
      }
      this._adjustOverlappingEvents($weekDay);

      setTimeout(function() {
        $oldCalEvent.remove();
      }, 1000);
    },

    /*
     * Add resizable capabilities to a calEvent
     */
    _addResizableToCalEvent(calEvent, $calEvent, $weekDay) {
      const self = this;
      const options = this.options;
      $calEvent.resizable({
        grid: options.timeslotHeight,
        containment: $weekDay,
        handles: 's',
        minHeight: options.timeslotHeight,
        stop(event, ui) {
          const $calEvent = ui.element;
          const newEnd = new Date(
            $calEvent.data('calEvent').start.getTime() +
              ($calEvent.height() / options.timeslotHeight) *
                options.millisPerTimeslot
          );
          const newCalEvent = $.extend(
            true,
            { start: calEvent.start, end: newEnd },
            calEvent
          );
          self._adjustForEventCollisions(
            $weekDay,
            $calEvent,
            newCalEvent,
            calEvent
          );

          self._refreshEventDetails(newCalEvent, $calEvent);
          self._positionEvent($weekDay, $calEvent);
          self._adjustOverlappingEvents($weekDay);
          // trigger resize callback
          options.eventResize(newCalEvent, calEvent, $calEvent);
          $calEvent.data('preventClick', true);
          setTimeout(function() {
            $calEvent.removeData('preventClick');
          }, 500);
        }
      });
    },

    /*
     * Refresh the displayed details of a calEvent in the calendar
     */
    _refreshEventDetails(calEvent, $calEvent) {
      // HINT: rendering of event info
      const self = this;
      const options = this.options;
      const title = Wahanda.Util.stringFalsyCheck(calEvent.title);
      const subTitle = Wahanda.Util.stringFalsyCheck(calEvent.subTitle);
      if (calEvent.type === 'appointment' || calEvent.type === 'multi-block') {
        self.renderCalendarTime(calEvent, $calEvent, calEvent);
      }
      $calEvent.find('.wc-title').text(title);
      $calEvent.find('.wc-subtitle').text(subTitle);
      $calEvent.attr('data-test', `calendar-appointment-${calEvent.id}`)
      $calEvent
        .find('.wc-client')
        .html(buildEventNameHtml(calEvent.client, calEvent.walkIn));

      let cls = `sal-event-${calEvent.fid}`;
      if (calEvent.venueCustomerId) {
        $calEvent.data(
          'consumer-day-id',
          App.Models.Appointment.getConsumerDateId(
            calEvent.venueCustomerId,
            calEvent.start
          )
        );
      }

      if (calEvent.fid == 2) {
        cls = 'sal-event-ok';
      } else if (calEvent.fid == 3) {
        cls = 'sal-event-web';
      } else if (calEvent.fid == 4) {
        cls = 'sal-event-conflict';
      } else if (calEvent.fid == 5) {
        cls = 'sal-event-nonwork';
      } else if (calEvent.fid == 6) {
        cls = 'sal-event-checkedout';
      } else if (calEvent.fid == 7) {
        cls = 'sal-event-web';
      } else if (calEvent.fid == 8) {
        cls = 'sal-event-full-block';
      } else if (calEvent.fid == 9) {
        cls = 'sal-event-partial-block';
      } else if (calEvent.fid == 10) {
        cls = 'sal-event-partial-block';
      } else if (calEvent.fid == 13) {
        cls = 'sal-event-noshow';
      }

      if (calEvent.recurring) {
        cls += ' sal-event-recurring';
      }
      if (calEvent.extraClasses) {
        cls += ` ${calEvent.extraClasses}`;
      }

      $calEvent.addClass(cls);

      if (calEvent.fid == 7) {
        $calEvent.find('.wc-lock').show();
      } else {
        $calEvent.find('.wc-lock').hide();
      }

      if (calEvent.isRepeated || calEvent.recurring) {
        $calEvent.find('.wc-repeated').show();
      }

      if (calEvent.checkedout) {
        $calEvent.find('.wc-checkedout').show();
      } else {
        if (calEvent.is_deposit_paid) {
          $calEvent.find('.wc-deposit').show();
        } else {
          $calEvent.find('.wc-deposit').hide();

          if (calEvent.no_deposit_warning) {
            $calEvent.find('.wc-no-deposit-warn').show();
          }
        }
      }

      if (calEvent.have_notes) {
        $calEvent.find('.wc-notes').show();
      } else {
        $calEvent.find('.wc-notes').hide();
      }

      if (calEvent.fid == 8 || calEvent.fid == 9) {
        $calEvent.append(
          $('<div>', { class: 'wc-click' }).text(
            Wahanda.lang.calendar.blockTime.labels.clickToExpand
          )
        );
      }

      $calEvent.data('calEvent', calEvent);
    },

    /*
     * Clear all cal events from the calendar
     */
    _clearCalendar() {
      this.element.find('.wc-day-column-inner div').remove();
    },

    _clearNonWorkSlots() {
      this.element.find('.wc-cal-non-work').remove();
    },

    _clearEvents() {
      this.element
        .find('.wc-cal-event, .wc-processing-time, .wc-finishing-time')
        .remove();
      if ($.isFunction(this.options.afterEventsCleared)) {
        this.options.afterEventsCleared();
      }
    },

    /*
     * Scroll the calendar to a specific hour
     */
    scrollToHour(hour) {
      const self = this;
      const options = this.options;
      const $scrollable = this.element.find('.wc-scrollable-grid');
      let slot = hour;
      if (self.options.businessHours.limitDisplay) {
        if (hour <= self.options.businessHours.start) {
          slot = 0;
        } else if (hour > self.options.businessHours.end) {
          slot =
            self.options.businessHours.end -
            self.options.businessHours.start -
            1;
        } else {
          slot = hour - self.options.businessHours.start;
        }
      }

      const $target = this.element.find(`.wc-hour-header:eq(${slot})`);
      if ($target && $target.offset()) {
        const targetOffset = $target.offset().top;
        const scroll =
          targetOffset -
          $scrollable.offset().top +
          $scrollable.get(0).scrollTop -
          $target.outerHeight();
        $scrollable.animate({ scrollTop: scroll }, options.scrollToHourMillis);
      }
    },

    /*
     * find the hour (12 hour day) for a given hour index
     */
    _hourForIndex(index) {
      if (index === 0) {
        // midnight
        return 12;
      }
      if (index < 13) {
        // am
        return index;
      }
      // pm
      return index - 12;
    },

    _24HourForIndex(index) {
      if (index === 0) {
        // midnight
        return '00';
      }
      if (index < 10) {
        return `0${index}`;
      }
      return index;
    },

    _amOrPm(hourOfDay) {
      return hourOfDay < 12 ? 'AM' : 'PM';
    },

    _isToday(date) {
      const clonedDate = this._cloneDate(date);
      this._clearTime(clonedDate);
      const today = adjustDate(new Date(), true);
      this._clearTime(today);
      return today.getTime() === clonedDate.getTime();
    },

    /*
     * Clean events to ensure correct format
     */
    _cleanEvents(events) {
      const self = this;

      $.each(events, function(i, event) {
        self._cleanEvent(event);
      });

      events = this._splitMultiDayEvents(events);

      return events;
    },

    _copyEvent(event) {
      return copyEvent(event);
    },

    _splitMultiDayEvents(events) {
      const n = events.length;
      const one_day = 1000 * 60 * 60 * 24;
      const weekStartDate = this._dateFirstDayOfWeek(this.options.date);
      const weekEndDate = this._dateLastMilliOfWeek(this.options.date);
      let event_end_date;
      let start;
      let end;
      let iSplit;
      let eventLength;

      for (let i = 0; i < n; i++) {
        // TODO: does not work on IE !!!
        const event = events[i];
        eventStart = this._cloneDate(event.start);
        eventEnd = this._cloneDate(event.end);
        eventLength = Math.ceil(
          (event.end.getTime() - event.start.getTime()) / one_day
        );
        if (event.start.getDate() != event.end.getDate() || eventLength > 1) {
          //        alert("Original: " + event.title + "\n" +eventStart.toString() + "\n" + eventEnd.toString());
          //        alert(eventLength);

          start = this._cloneDate(
            event.start >= weekStartDate ? event.start : weekStartDate
          );
          start = new Date(
            start.getFullYear(),
            start.getMonth(),
            start.getDate(),
            this._getCalendarStartTime()
          );
          end = event.end <= weekEndDate ? event.end : weekEndDate;
          iSplit = 1;

          while (start < end) {
            const dayEnd = new Date(
              start.getFullYear(),
              start.getMonth(),
              start.getDate(),
              this._getCalendarEndTime()
            );
            const dayStart = new Date(
              start.getFullYear(),
              start.getMonth(),
              start.getDate(),
              this._getCalendarStartTime()
            );
            //          alert(start);
            var newEvent;
            if (iSplit == 1) {
              newEvent = event;
            } else {
              newEvent = this._copyEvent(event);
              newEvent.start = eventStart;
              newEvent.end = eventEnd;
            }

            newEvent.oStart = eventStart;
            newEvent.oEnd = eventEnd;

            if (eventStart <= dayStart) {
              newEvent.start = new Date(
                start.getFullYear(),
                start.getMonth(),
                start.getDate(),
                this._getCalendarStartTime()
              );
              //            alert("from");
            }

            if (eventEnd >= dayEnd) {
              newEvent.end = new Date(
                start.getFullYear(),
                start.getMonth(),
                start.getDate(),
                this._getCalendarEndTime()
              );
              //            alert("to");
            }

            //          alert(newEvent.end);
            if (iSplit == 1) {
              events[i] = newEvent;
            } else if (newEvent.start.getTime() != newEvent.end.getTime()) {
              events.push(newEvent);
            }

            //          alert("New: " + newEvent.title + "\n" +newEvent.start.toString() + "\n" + newEvent.end.toString());

            start = this._addDays(start, 1, false);
            iSplit++;
          }
        }
      }

      return events;
    },

    /*
     * Clean specific event
     */
    _cleanEvent(event) {
      if (event.date) {
        event.start = event.date;
      }
      event.start = this._cleanDate(event.start);
      event.end = this._cleanDate(event.end);
      if (!event.end) {
        event.end = this._addDays(this._cloneDate(event.start), 1);
      }
    },

    /*
     * Disable text selection of the elements in different browsers
     */
    _disableTextSelect($elements) {
      $elements.each(function() {
        if ($.browser.mozilla) {
          // Firefox
          $(this).css('MozUserSelect', 'none');
        } else if ($.browser.msie) {
          // IE
          $(this).bind('selectstart', function() {
            return false;
          });
        } else {
          // Opera, etc.
          $(this).mousedown(function() {
            return false;
          });
        }
      });
    },

    /*
     * returns the date on the first millisecond of the week
     */
    _dateFirstDayOfWeek(date) {
      const self = this;
      let millisToSubtract = 0;
      const midnightCurrentDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      if (!this.options.dayView) {
        millisToSubtract =
          self._getAdjustedDayIndex(midnightCurrentDate) * 86400000;
      }
      const d = new Date(midnightCurrentDate.getTime() - millisToSubtract);
      const dif =
        d.getTimezoneOffset() - midnightCurrentDate.getTimezoneOffset();
      return new Date(d.getTime() + dif * 60000); // fix dst change during this week.
    },

    /*
     * returns the date on the first millisecond of the last day of the week
     */
    _dateLastDayOfWeek(date) {
      const self = this;
      let millisToAdd = 0;
      const midnightCurrentDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      if (!this.options.dayView) {
        millisToAdd =
          (6 - self._getAdjustedDayIndex(midnightCurrentDate)) * MILLIS_IN_DAY;
      }
      return addTimeToDate(midnightCurrentDate, millisToAdd / 60000);
    },

    /*
     * gets the index of the current day adjusted based on options
     */
    _getAdjustedDayIndex(date) {
      const midnightCurrentDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      const currentDayOfStandardWeek = midnightCurrentDate.getDay();
      const days = [0, 1, 2, 3, 4, 5, 6];
      this._rotate(days, this.options.firstDayOfWeek);
      return days[currentDayOfStandardWeek];
    },

    /*
     * returns the date on the last millisecond of the week
     */
    _dateLastMilliOfWeek(date) {
      const lastDayOfWeek = this._dateLastDayOfWeek(date);
      return addTimeToDate(lastDayOfWeek, MILLIS_IN_DAY / 60000);
    },

    /*
     * Clear the time components of a date leaving the date
     * of the first milli of day
     */
    _clearTime(d) {
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);
      return d;
    },

    /*
     * add specific number of days to date
     */
    _addDays(d, n, keepTime) {
      d.setDate(d.getDate() + n);
      if (keepTime) {
        return d;
      }
      return this._clearTime(d);
    },

    /*
     * Rotate an array by specified number of places.
     */
    _rotate(
      a /* array */,
      p /* integer, positive integer rotate to the right, negative to the left... */
    ) {
      for (
        var l = a.length,
          p = (Math.abs(p) >= l && (p %= l), p < 0 && (p += l), p),
          i,
          x;
        p;
        p = (Math.ceil(l / p) - 1) * p - l + (l = p)
      ) {
        for (i = l; i > p; x = a[--i], a[i] = a[i - p], a[i - p] = x);
      }
      return a;
    },

    _cloneDate(d) {
      return new Date(d.getTime());
    },

    /*
     * return a date for different representations
     */
    _cleanDate(d) {
      if (typeof d === 'string') {
        return (
          $.resourceCalendar.parseISO8601(d, true) ||
          Date.parse(d) ||
          new Date(parseInt(d))
        );
      }
      if (typeof d === 'number') {
        return new Date(d);
      }
      return d;
    },

    /*
     * date formatting is adapted from
     * http://jacwright.com/projects/javascript/date_format
     */
    _formatDate(date, format) {
      const options = this.options;
      let returnStr = '';
      for (let i = 0; i < format.length; i++) {
        const curChar = format.charAt(i);
        if ($.isFunction(this._replaceChars[curChar])) {
          returnStr += this._replaceChars[curChar](date, options);
        } else {
          returnStr += curChar;
        }
      }
      return returnStr;
    },

    _replaceChars: {
      // Day
      d(date) {
        return (date.getDate() < 10 ? '0' : '') + date.getDate();
      },
      D(date, options) {
        return options.shortDays[date.getDay()];
      },
      j(date) {
        return date.getDate();
      },
      l(date, options) {
        return options.longDays[date.getDay()];
      },
      N(date) {
        return date.getDay() + 1;
      },
      S(date) {
        return date.getDate() % 10 == 1 && date.getDate() != 11
          ? 'st'
          : date.getDate() % 10 == 2 && date.getDate() != 12
          ? 'nd'
          : date.getDate() % 10 == 3 && date.getDate() != 13
          ? 'rd'
          : 'th';
      },
      w(date) {
        return date.getDay();
      },
      z(date) {
        return 'Not Yet Supported';
      },
      // Week
      W(date) {
        return 'Not Yet Supported';
      },
      // Month
      F(date, options) {
        return options.longMonths[date.getMonth()];
      },
      m(date) {
        return (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1);
      },
      M(date, options) {
        return options.shortMonths[date.getMonth()];
      },
      n(date) {
        return date.getMonth() + 1;
      },
      t(date) {
        return 'Not Yet Supported';
      },
      // Year
      L(date) {
        return 'Not Yet Supported';
      },
      o(date) {
        return 'Not Supported';
      },
      Y(date) {
        return date.getFullYear();
      },
      y(date) {
        return `${date.getFullYear()}`.substr(2);
      },
      // Time
      a(date) {
        return date.getHours() < 12 ? 'am' : 'pm';
      },
      A(date) {
        return date.getHours() < 12 ? 'AM' : 'PM';
      },
      B(date) {
        return 'Not Yet Supported';
      },
      g(date) {
        return date.getHours() % 12 || 12;
      },
      G(date) {
        return date.getHours();
      },
      h(date) {
        return (
          ((date.getHours() % 12 || 12) < 10 ? '0' : '') +
          (date.getHours() % 12 || 12)
        );
      },
      H(date) {
        return (date.getHours() < 10 ? '0' : '') + date.getHours();
      },
      i(date) {
        return (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
      },
      s(date) {
        return (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();
      },
      // Timezone
      e(date) {
        return 'Not Yet Supported';
      },
      I(date) {
        return 'Not Supported';
      },
      O(date) {
        return `${(date.getTimezoneOffset() < 0 ? '-' : '+') +
          (date.getTimezoneOffset() / 60 < 10 ? '0' : '') +
          date.getTimezoneOffset() / 60}00`;
      },
      T(date) {
        return 'Not Yet Supported';
      },
      Z(date) {
        return date.getTimezoneOffset() * 60;
      },
      // Full Date/Time
      c(date) {
        return 'Not Yet Supported';
      },
      r(date) {
        return date.toString();
      },
      U(date) {
        return date.getTime() / 1000;
      }
    }
  });

  $.extend($.ui.resourceCalendar, {
    version: '1.0.1',
    getter: [
      'getTimeslotTimes',
      'getData',
      'formatDate',
      'formatTime',
      'getDateRange',
      'getResourceID',
      'getViewType'
    ],
    defaults: {
      date: new Date(),
      timeFormat: 'h:i a',
      dateFormat: 'M d, Y',
      use24Hour: false,
      daysToShow: 7,
      firstDayOfWeek: 0, // 0 = Sunday, 1 = Monday, 2 = Tuesday, ... , 6 = Saturday
      useShortDayNames: false,
      timeSeparator: ' to ',
      startParam: 'start',
      endParam: 'end',
      businessHours: { start: 8, end: 18, limitDisplay: false },
      newEventText: 'New Event',
      timeslotHeight: 20,
      defaultEventLength: 2,
      timeslotsPerHour: 4,
      buttons: true,
      buttonText: {
        today: 'today',
        lastWeek: '&nbsp;&lt;&nbsp;',
        nextWeek: '&nbsp;&gt;&nbsp;'
      },
      scrollToHourMillis: 500,
      allowCalEventOverlap: false,
      overlapEventsSeparate: false,
      readonly: false,
      draggable(calEvent, element) {
        return true;
      },
      resizable(calEvent, element) {
        return true;
      },
      eventClick() {},
      eventRender(calEvent, element) {
        return element;
      },
      eventAfterRender(calEvent, element) {
        return element;
      },
      eventDrag(calEvent, element) {},
      eventDrop(calEvent, element) {},
      eventResize(calEvent, element) {},
      eventNew(calEvent, element) {},
      eventMouseover(calEvent, $event) {},
      eventMouseout(calEvent, $event) {},
      calendarBeforeLoad(calendar) {},
      calendarAfterLoad(calendar) {},
      noEvents() {},
      isHeaderNavigationEnabled() {
        return true;
      },
      shortMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ],
      longMonths: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      longDays: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ],
      dayView: false,
      ridParam: 'rid',
      resourceID: 0
    }
  });

  var MILLIS_IN_DAY = 86400000;
  var MILLIS_IN_WEEK = MILLIS_IN_DAY * 7;

  $.resourceCalendar = (function() {
    return {
      parseISO8601(s, ignoreTimezone) {
        // derived from http://delete.me.uk/2005/03/iso8601.html
        const regexp =
          '([0-9]{4})(-([0-9]{2})(-([0-9]{2})' +
          '(T([0-9]{2}):([0-9]{2})(:([0-9]{2})(.([0-9]+))?)?' +
          '(Z|(([-+])([0-9]{2}):([0-9]{2})))?)?)?)?';
        const d = s.match(new RegExp(regexp));
        if (!d) return null;
        let offset = 0;
        const date = new Date(d[1], 0, 1);
        if (d[3]) {
          date.setMonth(d[3] - 1);
        }
        if (d[5]) {
          date.setDate(d[5]);
        }
        if (d[7]) {
          date.setHours(d[7]);
        }
        if (d[8]) {
          date.setMinutes(d[8]);
        }
        if (d[10]) {
          date.setSeconds(d[10]);
        }
        if (d[12]) {
          // Disabled due to posisble incorrect handling in case of
          // timezone offset is provided - treats timezone as miliseconds
          // date.setMilliseconds(Number("0." + d[12]) * 1000);
        }
        if (!ignoreTimezone) {
          if (d[14]) {
            offset = Number(d[16]) * 60 + Number(d[17]);
            offset *= d[15] == '-' ? 1 : -1;
          }
          offset -= date.getTimezoneOffset();
        }
        return new Date(Number(date) + offset * 60 * 1000);
      }
    };
  })();
})(jQuery);
